export const Routes = {
    DND: "/airtel-dnd",
    CONSENT: "/user-consent"
}